import React, { forwardRef, useEffect, useMemo, useState } from "react";

import { useParams } from "react-router-dom";
import moment from "moment";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import api from "../../api";
import DownloadLink from "../../components/common/DownloadLink";
import useNavProject from "../../hooks/useNavProject";
import BackBtn from "../../components/UI/BackBtn";
import { years } from "../../helpers";
import YearSelect from "../../components/common/YearSelect";
import AddMember from "../../components/Members/AddMember";
import EditMember from "../../components/Members/EditMember";
import TableProject from "../../components/Members/TableProject";
import { isAdmin, isPortfolioTeam, isProjectTeam, isCommandManagmentOrProjOffice, isStrategyTeam } from "../../services/rolesSvc";
import useUserContext from "../../hooks/useUserContext";
import { status_ru_m } from "../../helpers/factdata";
import {status as PS} from "../../helpers/passport";
import {BaseRequests} from "../../requests/BaseRequests";

const options = [
  { value: "", label: "Все статусы" },
  ...Object.entries(status_ru_m).map(([key, value]) => ({ value: key, label: value })),
];

export default function ProjectMembers() {
  const navProject = useNavProject();
  const { stratId, portfolioId, projId } = useParams();
  const [year, setYear] = useState(Number(2025));
  const [modalAddMember, setModalAddMember] = useState(false);
  const [editMemberID, setEditMemberID] = useState(null);
  const [proj, setProj] = useState(null);
  const [filterStatus, setFilterStatus] = useState(options[0]);
  const userCtx = useUserContext();
  const editable = useMemo(
    () => ((isProjectTeam(userCtx, projId) || isPortfolioTeam(userCtx, portfolioId)) && ![PS.closed].includes(proj?.status) || isAdmin(userCtx)),
    [userCtx,proj]
  );

  useEffect(async () => {
    const respProj = await api.get(`/structure/projs/${projId}?latest=true`);
    if (!respProj || respProj.error) return;
    setProj(respProj);
    navProject.setStratTitle(respProj.strategy?.name);
    navProject.setPolicyTitle(respProj.policy?.name);
    if (respProj.portfolio) {
      navProject.setPortfolioTitle(respProj.portfolio?.name);
      navProject.setPortfProjTitle(respProj.name);
    } else navProject.setProjTitle(respProj.name);
  }, []);

  return (
    <section className="page strat-proj-report-page">
      <div className="container" style={!!(modalAddMember || editMemberID) ? {background:'#F5F5FF'} : {}}>
        <div style={{ marginBottom: 16 }}>
          {!(editMemberID || modalAddMember) ? (
            <BackBtn />
          ) : (
            <div className="back-btn">
              <button
                onClick={() => {
                  setModalAddMember(false);
                  setEditMemberID(null);
                }}
              >
                Вернуться назад
              </button>
            </div>
          )}
        </div>
        {modalAddMember && <h3 style={styledHeading}>Добавить участника</h3>}
        {editMemberID && <h3 style={styledHeading}>Редактировать участника</h3>}
        {!(modalAddMember || editMemberID) && (
          <>
            <h3 style={styledHeading}>Участники команды</h3>
            {isCommandManagmentOrProjOffice(userCtx, stratId, projId, projId) && (
              <div style={styledContainer} className="d-flex align-items-end flex-wrap">
                <div style={{ minWidth: "144px" }}>
                  <div style={{ color: "black", fontSize: "16px", marginBottom: "10px", fontWeight: "600" }}>Год</div>
                  <YearSelect year={year} years={years} onChange={(e) => setYear(e.value)} />
                </div>
                <div style={{ minWidth: "200px", marginLeft: "16px" }}>
                  <div
                    style={{
                      color: "black",
                      fontSize: "16px",
                      marginBottom: "10px",
                      fontWeight: "600",
                    }}
                  >
                    Статус
                  </div>
                  <Select
                    defaultValue={filterStatus}
                    options={options}
                    onChange={(e) => {
                      setFilterStatus(e);
                    }}
                  />
                </div>
                <div>
                  <DownloadLink
                    style={{ marginLeft: "16px" }}
                    variant="outline-primary"
                    url={BaseRequests.getUrlSearch('/factdata/teammembers/0/export',{portfId:portfolioId,projId,year})}
                    // url={`/factdata/teammembers/0/export?portfId=${portfolioId}&projId=${projId}&year=${year}`}
                    filename={`Участники команды проект (№${proj?.fullNumber})_${moment().format("DD.MM.yyyy")}.xlsx`}
                  >
                    Выгрузить в xls
                  </DownloadLink>
                  {!!editable && (
                    <Button
                      style={{ marginLeft: "16px" }}
                      onClick={() => setModalAddMember((prev) => !prev)}
                      variant="primary"
                    >
                      + Добавить участника
                    </Button>
                  )}

                </div>
              </div>
            )}
          </>
        )}
        {modalAddMember ? (
          <AddMember closeCard={() => setModalAddMember(false)} />
        ) : (
          <>
            {!editMemberID && (
              <TableProject canEdit={!!editable} projStatus = {proj?.status} filterStatus={filterStatus.value} year={year} setEditMemberID={setEditMemberID} />
            )}
          </>
        )}
        {editMemberID && <EditMember id={editMemberID} closeCard={() => setEditMemberID(null)} />}
      </div>
    </section>
  );
}

const styledHeading = { marginBottom: 24, textAlign: "left", color: "#1F2125" };
const styledContainer = {
  display: "flex",
  zIndex: 21,
  position: "relative",
  top: 70,
  marginTop: -70,
  marginBottom: "20px",
};
